import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
import { getMarketplace } from 'src/utils/marketplace';
import { hasSmaBridge } from 'src/utils/messages';
import { getMobileOperatingSystem, getSma } from 'src/utils/user';
export class CloudWatchRum {
    constructor() {
        // TODO: Add queuing logic to buffer events if cwr loads after initial check.
        // In most cases, cwr should be immediately available when the app loads.
        // Set up a timeout to check again and log if not available
        setTimeout(() => {
            if (typeof window.cwr === 'undefined') {
                console.warn('Cloudwatch not initialized.');
            }
        }, 5000);
        // Add sma, os, marketplace, and bridge-presence session attributes immediately on load.
        // As session attributes these land in $.metadata.* on every RUM event — including the
        // auto-collected load events — so a dashboard can split any rate by hasBridge, the same way
        // the per-placement metrics slice by sma/os/marketplace. hasBridge captures whether the host
        // SMA injected its message handler; a fallback redirect can only deep link into mShop when it
        // did, so its rate is worth watching separately for bridge vs no-bridge sessions.
        const searchParams = new URLSearchParams(window.location.search);
        this.addSessionAttributes({
            sma: getSma(),
            os: getMobileOperatingSystem(),
            marketplace: getMarketplace(searchParams),
            hasBridge: hasSmaBridge(),
        });
    }
    recordEvent(eventType, eventData) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('recordEvent', { type: eventType, data: eventData });
        }
    }
    addSessionAttributes(sessionAttributes) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('addSessionAttributes', sessionAttributes);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recordError(error) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('recordError', error);
        }
    }
}
export const defaultRumClient = new CloudWatchRum();
export const AnalyticsContext = createContext(defaultRumClient);
// For ease of testing
export const useAnalyticsContext = () => React.useContext(AnalyticsContext);
export const AnalyticsProvider = ({ children }) => {
    return _jsx(AnalyticsContext.Provider, { value: defaultRumClient, children: children });
};
